import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useCapitalDecreaseModal } from '../context/CapitalDecreaseModalContext';

const CapitalDecreaseModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useCapitalDecreaseModal();

  const buttonEnabledSaveMovement =
    data.sharesRanges.length > 0 && data.remainingShares >= 0;

  const buttonEnabledScriptureView =
    data.scriptureView &&
    data.date &&
    data.totalSharesToDecrease < data.societyActualShares &&
    data.totalSharesToDecrease > 0;

  const buttonEnabledMovementsView =
    !data.scriptureView &&
    data.remainingShares === 0 &&
    data.sharesRanges.length === 0;

  const buttonText = data.scriptureView ? t('Next') : t('SaveOperation');

  return (
    <>
      <Modal.Footer>
        <div className="d-flex justify-content-between w-100">
          {!data.scriptureView && (
            <button
              type="button"
              className="btn btn-lg btn-primary"
              onClick={actions.handleSaveMovement}
              disabled={!buttonEnabledSaveMovement}
            >
              {t('SaveMovement')}
            </button>
          )}
          <button
            type="button"
            className="btn btn-lg btn-primary"
            onClick={actions.handleSaveCapitalDecrease}
            disabled={
              !buttonEnabledScriptureView && !buttonEnabledMovementsView
            }
          >
            {buttonText}
          </button>
        </div>
      </Modal.Footer>
    </>
  );
};

export default CapitalDecreaseModalFooter;
